import axios from 'axios';
import { getToken } from './auth';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_URL}`
});

api.interceptors.request.use(async config => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        
    }
    return config;
});

api.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (error.response?.status === 401 && window.location.href.indexOf("login") <= -1) {
        window.location.href="/login";
    }
    return Promise.reject(error);
});

export default api;